if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      if(this.querySelector('.loading-overlay__spinner')){
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


/* Centric: require explicit Style and Size selection */
(function () {
  const pendingClass = 'required-selection-pending';
  const requiredSelector = 'fieldset.size-variant, fieldset.liner-variant';

  function getButtonTextElement(button) {
    return button.querySelector('span') || button;
  }

  function getOptionName(group) {
    const handle = group.getAttribute('option-handle');
    if (handle) return handle.trim();

    const legend = group.querySelector('.form__label');
    if (!legend) return 'option';

    return legend.textContent
      .replace(/Size Guide|Find Your Fit/gi, '')
      .split(':')[0]
      .trim();
  }

  function getRequiredGroups(section) {
    const picker =
      section.querySelector('.product__info-wrapper variant-radios') ||
      section.querySelector('variant-radios');

    if (!picker) return [];

    return Array.from(picker.querySelectorAll(requiredSelector)).filter(function (group) {
      return group.querySelector('input[type="radio"]');
    });
  }

  function updateSectionState(section) {
    const groups = getRequiredGroups(section);
    if (!groups.length) return;

    const remaining = groups.filter(function (group) {
      return group.dataset.explicitlySelected !== 'true';
    });

    const ready = remaining.length === 0;
    section.dataset.explicitVariantSelection = ready ? 'true' : 'false';

    section.querySelectorAll('product-form').forEach(function (productForm) {
      const button = productForm.querySelector('[name="add"], [type="submit"]');
      if (!button) return;

      const textElement = getButtonTextElement(button);

      if (!button.dataset.originalSelectionText) {
        button.dataset.originalSelectionText = textElement.textContent.trim();
      }

      if (!ready) {
        const names = remaining.map(getOptionName);
        const uniqueNames = names.filter(function (name, index) {
          return names.indexOf(name) === index;
        });

        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.selectionLocked = 'true';
        textElement.textContent = 'SELECT ' + uniqueNames.join(' & ').toUpperCase();
      } else if (button.dataset.selectionLocked === 'true') {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        button.dataset.selectionLocked = 'false';
        textElement.textContent = button.dataset.originalSelectionText || 'ADD TO CART';
      }
    });
  }

  function initializeSection(section) {
    const groups = getRequiredGroups(section);
    if (!groups.length || section.dataset.selectionRequirementInitialized === 'true') return;

    section.dataset.selectionRequirementInitialized = 'true';

    groups.forEach(function (group) {
      group.dataset.explicitlySelected = 'false';
      group.classList.add(pendingClass);

      function markGroupSelected() {
        group.dataset.explicitlySelected = 'true';
        group.classList.remove(pendingClass);

        window.setTimeout(function () {
          updateSectionState(section);
        }, 0);
      }

      group.addEventListener('click', function (event) {
        const label = event.target.closest('label');
        if (!label || !group.contains(label)) return;

        const inputId = label.getAttribute('for');
        const input = inputId ? document.getElementById(inputId) : null;
        if (!input || input.disabled) return;

        markGroupSelected();
      });

      group.addEventListener('change', function (event) {
        if (!event.target.matches('input[type="radio"]')) return;
        markGroupSelected();
      });
    });

    updateSectionState(section);
  }

  function initializeRequiredSelections() {
    if (!document.getElementById('required-variant-selection-styles')) {
      const style = document.createElement('style');
      style.id = 'required-variant-selection-styles';
      style.textContent =
        '.' + pendingClass + ' input[type="radio"]:checked + label {' +
        'border-color: #d8d8d8 !important;' +
        'box-shadow: none !important;' +
        'background: transparent !important;' +
        '}';
      document.head.appendChild(style);
    }

    document.querySelectorAll('section.main-prouct, .main-prouct').forEach(initializeSection);
  }

  document.addEventListener(
    'submit',
    function (event) {
      const section = event.target.closest('.main-prouct');
      if (!section || section.dataset.explicitVariantSelection !== 'false') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      updateSectionState(section);

      const firstPending = section.querySelector('.' + pendingClass);
      if (firstPending) firstPending.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeRequiredSelections);
  } else {
    initializeRequiredSelections();
  }
})();
